import React, { useEffect } from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;

  return (
    <section className="privacy-policy-page">
      <div className='privacy-policy-header'>
        <h1 className="privacy-policy-title"><span>Privacy </span>Policy</h1>
        <p className="privacy-policy-update-date"><span>Last Updated: 16/03/2026</span></p>
        </div>
      <div className="privacy-policy-content">
        <p>
          Welcome to Reddy Anna Book's Privacy Policy. Your privacy and
          the security of your information are of utmost importance to us. This
          Privacy Policy outlines the types of personal information we collect,
          how it is used, and the measures we take to protect your data.
        </p>

        <h2>1. Information We Collect:</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> When you register an account,
            we may collect personal details such as your name, email address,
            contact number, and date of birth.
          </li>
          <li>
            <strong>Financial Information:</strong> To facilitate transactions,
            we may collect payment information, including credit card details or
            other payment methods.
          </li>
          <li>
            <strong>Usage Information:</strong> We collect information about
            your interactions with our platform, including the games you play,
            bets placed, and your navigation through the website.
          </li>
        </ul>

        <h2>2. How We Use Your Information:</h2>
        <p>We use the collected information for the following purposes:</p>
        <ul>
          <li>
            <strong>Account Management:</strong> To manage your account, provide
            customer support, and verify your identity.
          </li>
          <li>
            <strong>Transaction Processing:</strong> To process your bets,
            deposits, and withdrawals.
          </li>
          <li>
            <strong>Improving User Experience:</strong> To enhance our services,
            personalize your experience, and analyze user preferences.
          </li>
          <li>
            <strong>Communications:</strong> To send you updates, promotional
            offers, and important notifications related to your account.
          </li>
        </ul>

        <h2>3. Data Security:</h2>
        <p>
          We implement security measures to protect your information from
          unauthorized access, disclosure, alteration, and destruction. Our
          secure encryption protocols and regular security audits help ensure
          the integrity of your data.
        </p>

        <h2>4. Third-Party Disclosures:</h2>
        <p>
          We may share your information with trusted third parties for specific
          purposes, such as payment processing and marketing communications.
          However, we do not sell, trade, or otherwise transfer your personally
          identifiable information to outside parties without your consent.
        </p>

        <h2>5. Cookies and Tracking:</h2>
        <p>
          We use cookies and similar tracking technologies to enhance your
          browsing experience and collect information about your activities on
          our platform. You can manage your cookie preferences through your
          browser settings.
        </p>

        <h2>6. Your Privacy Choices:</h2>
        <p>
          You have the right to access, correct, or delete your personal
          information. You can also manage your communication preferences by
          opting in or out of certain communications.
        </p>

        <h2>7. Changes to the Privacy Policy:</h2>
        <p>
          This Privacy Policy is subject to change. We will notify you of any
          material changes, and the updated policy will be effective upon
          posting.
        </p>

        <p>
          By using Reddy Anna Book Official, you signify your acceptance of this
          Privacy Policy. If you have any questions or concerns, please contact
          us at <a href={ContactLink}>+91 6666856666</a>.
        </p>

        <p>
          Thank you for choosing Reddy Anna Book Official. Your privacy and
          trust are fundamental to our commitment to providing a secure and
          enjoyable gaming experience.
        </p>
      </div>
      <div className="privacy-btn">
      <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 6666856666
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 6666066663
          </a>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
